function nullToString(str) {
  if (str == null) {
    return "None";
  } else {
    return str;
  }
}

export default nullToString;
